import(/* webpackMode: "eager", webpackExports: ["AskPanel"] */ "/app/components/comparison/broadcast/AskPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CheaperElsewhereStrip"] */ "/app/components/comparison/CheaperElsewhereStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonNotFound"] */ "/app/components/comparison/ComparisonNotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonUpdating"] */ "/app/components/comparison/ComparisonUpdating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FreshnessRibbon"] */ "/app/components/comparison/FreshnessRibbon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MissingPageGate"] */ "/app/components/comparison/MissingPageGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PriceBeatCallout"] */ "/app/components/comparison/PriceBeat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductLiveBuild"] */ "/app/components/comparison/ProductLiveBuild.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RetailerListFold"] */ "/app/components/comparison/RetailerListFold.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchAgainBar"] */ "/app/components/comparison/SearchAgainBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubmittedClaimsProvider"] */ "/app/components/comparison/SubmittedClaimsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonRow"] */ "/app/components/comparison/v2/ComparisonRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/app/components/comparison/v2/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WalkAwayTracker"] */ "/app/components/comparison/WalkAwayTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecordComparisonView"] */ "/app/components/searches/RecordComparisonView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
